import React, { useState, useEffect } from 'react';
import {defaultStatusColumns, PCEColumns, shouldDisable} from './status.utils';


import { Col, Checkbox, Row, Input } from 'antd';
import IpsDTCommentsIcon from 'components/CommentsIcon/IpsDTCommentsIcon';
import StatusTable from './statusTable/index.js';
import CommentBox from './DailogBox';
import {isAdministrator} from "../../utils/UserInfo";

function PCEView(props) {
  const {
    project,
    handleProjectDetailUpdate,
    comments,
    isReadOnly,
    PCEDropDownOptions,
    phaseDetails,
    phaseId,
    isProjectOnHold,
  } = props;

  const [selectedDropdownOptions, setSelectedDropdownOptions] = useState([]);

  useEffect( () => {
  //   if (phaseDetails?.pceAssetsStatus !== null) {
  //     let options = [];
  //     let index = PCEDropDownOptions.indexOf(phaseDetails?.pceAssetsStatus);
  //     // We are checking here if we have status 'IPS Locations Created then we will show 2 options
  //     if(index < 5) options.push(PCEDropDownOptions[index+1]);
  //     if(index <= 5 && index > 0) options.push(PCEDropDownOptions[index-1]);
  //     setSelectedDropdownOptions(options);
  //   }
  //   else {
      setSelectedDropdownOptions([...PCEDropDownOptions]);
    // }
  }, [phaseDetails?.pceAssetsStatus, PCEDropDownOptions]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [PCEAssetsExpected,setPCEAssetsExpected]=useState( phaseDetails
    ? phaseDetails.expectedPCEAssetsCnt
    : 0)

  const handleCommentDialogueSubmit = (comment) => {
    handleProjectDetailUpdate(`N-${comment}`, 'PCE_ASSETS_FLAG', 'string',phaseId);

    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const PCEAssetSheetHandler = (e) => {
    let value = e.target.checked ? 'N' : 'Y';
    if (e.target.checked) {
      setIsModalOpen(true);
    } else {
      handleProjectDetailUpdate(value, 'PCE_ASSETS_FLAG', 'string',phaseId);
    }
  };
  let handleNoOfAssetsChange = () => {
    handleProjectDetailUpdate(PCEAssetsExpected, 'EXPECTED_PCE_ASSETS_CNT', 'number',phaseId);
  };

  const setNoPCEAssetsExpected = (e) => {
    const { value } = e.target;
    const reg = /^-?[0-9]*(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
      setPCEAssetsExpected(Number(value));
    }
  }
  return (
    <>
      <div>
        <section className='padding-container'>
          <Row justify='end' align='middle' gutter={25}>
            <Col className='d-flex flex-column'>
              <div className='d-flex flex-row'>
              <span className='key-title pr-1'>CCA SLA:</span>
              {phaseDetails?.pceAssetsSLA &&
                  ` ${phaseDetails?.pceAssetsSLA}`}
                </div>
              <div className='d-flex flex-row'>
                <span className='key-title pr-1'>Engineering SLA:</span>
                {phaseDetails?.pceAssetsEngSLA &&
                ` ${phaseDetails?.pceAssetsEngSLA}`}
              </div>
              <div className='d-flex flex-row'>
                <span className='key-title pr-1'>Total SLA:</span>
                {` ${(phaseDetails.pceAssetsSLA===null?0:phaseDetails.pceAssetsSLA) + (phaseDetails.pceAssetsEngSLA===null?0:phaseDetails.pceAssetsEngSLA)}`}
              </div>
            </Col>
            <Col>
              <IpsDTCommentsIcon
                project={project}
                comments={comments}
                commentGroup={'PCE'}
                phase={phaseId}

              />
            </Col>
          </Row>
          <Row className='se-pce-space'>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 12,
              }}
              xxl={{
                span: 12,
              }}
            >
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  PCE Asset Sheets
                </Col>
                <Col>
                  <Checkbox
                    onChange={PCEAssetSheetHandler}
                    defaultChecked={false}
                    checked={phaseDetails?.pceAssetsFlag === 'N'}
                    name='selected'
                    style={{
                      display: 'flex',
                      border: 'none',
                      padding: 0,
                      margin: 0,
                    }}
                    disabled={isReadOnly||isProjectOnHold}
                  />
                </Col>
                <Col
                  style={{ marginLeft: '5px' }}
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  N/A
                </Col>
                <CommentBox
                  show={isModalOpen}
                  handleCommentDialogueSubmit={handleCommentDialogueSubmit}
                  name={'PCE Assets Sheet'}
                  handleCancel={handleCancel}
                />
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  {''}
                </Col>
                {phaseDetails && phaseDetails.pceChangedDate && (
                  <Col>{`${phaseDetails.pceChangedUser}  ${phaseDetails.pceChangedDate}`}</Col>
                )}
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  {''}
                </Col>
                {phaseDetails && phaseDetails.pceChangedDate && phaseDetails.pceAssetsComments&& (
                  <Col>{`${phaseDetails.pceAssetsComments}`}</Col>
                )}
              </Row>
            </Col>

            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 12,
              }}
              xxl={{
                span: 12,
              }}
            >
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  PCE Engineer:
                </Col>
                {project && project.pceNames && (
                  <Col>{`${project.pceNames}`}</Col>
                )}
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  PCE Assets Expected:
                </Col>
                <Col className='asset-input'>
                 
                  <Input
                    size='small'
                    
                    value={
                     PCEAssetsExpected
                    }
                    onChange={setNoPCEAssetsExpected}
                    onBlur={handleNoOfAssetsChange}
                    disabled={
                      isReadOnly ||isProjectOnHold|| phaseDetails?.pceAssetsFlag === 'N'
                    }

                  />
                </Col>
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  PCE Assets Received :
                </Col>
                <Col>{project.noOfPCEAssets}</Col>
              </Row>
            </Col>
          </Row>
          <StatusTable
            dataSource={phaseDetails?.pceAssetsHistory}
            dropOptions={selectedDropdownOptions}
            disabledButtons={
              isReadOnly ||isProjectOnHold||
              phaseDetails?.pceAssetsFlag === 'N' ||
              shouldDisable(
                phaseDetails?.pceAssetsStatus ===
                  selectedDropdownOptions[selectedDropdownOptions?.length - 1]
              )
            }
            fieldName = {'PCE_ASSETS_STATUS'}
            currentStatus = {phaseDetails.pceAssetsStatus}
            phaseId = {phaseId}
            disableDelete = {project.trackerStatus === 'DT_C' ? true : false}
            handleProjectDetailUpdate = {handleProjectDetailUpdate}
          />
        </section>
      </div>
    </>
  );
}
export default PCEView;